(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instanceSequence = 0;

  function getScopedRoots(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-ag-cf-common]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-ag-cf-common]')));
    return roots;
  }

  function sanitizeId(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || 'instance';
  }

  function resolveInstanceId(root, kind) {
    if (root.dataset.agCfCommonInstanceId) return root.dataset.agCfCommonInstanceId;

    var requested = root.dataset.agCfCommonPrefix;
    var base = requested ? sanitizeId(requested) : 'ag-cf-common-' + sanitizeId(kind);
    var candidate = base;

    if (!requested) {
      instanceSequence += 1;
      candidate += '-' + instanceSequence;
    }

    while (document.getElementById(candidate)) {
      instanceSequence += 1;
      candidate = base + '-' + instanceSequence;
    }

    root.id = candidate;
    root.dataset.agCfCommonInstanceId = candidate;
    return candidate;
  }

  function setTargetId(element, id) {
    if (element) element.id = id;
    return id;
  }

  function createNavigation(slider, track, slides) {
    var dotsContainer = slider.querySelector('[data-ag-cf-common-dots]');
    var stepsContainer = slider.querySelector('[data-ag-cf-common-steps]');
    var dotTemplate = slider.dataset.agCfCommonDotLabel || 'Go to slide __NUMBER__';
    var stepRailLabel = slider.dataset.agCfCommonStepRailLabel || 'Slider states';
    var dots = [];
    var steps = [];

    if (dotsContainer) {
      dotsContainer.replaceChildren();
      dotsContainer.hidden = slides.length < 2;
      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ag-cf-common__dot';
        dot.dataset.agCfCommonDot = '';
        dot.dataset.agCfCommonIndex = String(index);
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', dotTemplate.replace('__NUMBER__', String(index + 1)));
        dot.setAttribute('aria-controls', slide.id);
        dotsContainer.appendChild(dot);
        dots.push(dot);
      });
    }

    if (stepsContainer) {
      stepsContainer.replaceChildren();
      stepsContainer.hidden = slides.length < 2;
      stepsContainer.setAttribute('aria-label', stepRailLabel);
      slides.forEach(function (slide, index) {
        var label = slide.dataset.agCfCommonStepLabel;
        if (!label) return;
        var item = document.createElement('li');
        var step = document.createElement('button');
        step.type = 'button';
        step.className = 'ag-cf-common__step';
        step.dataset.agCfCommonStep = '';
        step.dataset.agCfCommonIndex = String(index);
        step.setAttribute('role', 'tab');
        step.setAttribute('aria-label', label);
        step.setAttribute('aria-controls', slide.id);
        step.textContent = label;
        item.appendChild(step);
        stepsContainer.appendChild(item);
        steps.push(step);
      });
    }

    return { dots: dots, steps: steps };
  }

  function initSlider(slider) {
    if (slider.dataset.agCfCommonReady === 'true') return;

    var root = slider.closest('[data-ag-cf-common]');
    var track = slider.querySelector('[data-ag-cf-common-slider-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-ag-cf-common-slide]')) : [];
    var previous = slider.querySelector('[data-ag-cf-common-prev]');
    var next = slider.querySelector('[data-ag-cf-common-next]');
    var progress = slider.querySelector('[data-ag-cf-common-progress]');
    var kind = slider.dataset.agCfCommonSliderKind || 'slider';

    if (!root || !track) return;
    slider.dataset.agCfCommonReady = 'true';

    var instanceId = resolveInstanceId(root, kind);
    var title = root.querySelector('[data-ag-cf-common-title]');
    var trackId = setTargetId(track, instanceId + '-track');
    if (title) root.setAttribute('aria-labelledby', setTargetId(title, instanceId + '-title'));

    slides.forEach(function (slide, index) {
      setTargetId(slide, trackId + '-slide-' + (index + 1));
    });

    var navigation = createNavigation(slider, track, slides);
    var dots = navigation.dots;
    var steps = navigation.steps;

    if (slides.length === 0) {
      if (kind === 'transformation' || kind === 'story') root.hidden = true;
      slider.hidden = true;
      return;
    }

    function update(index) {
      var current = Math.max(0, Math.min(index, slides.length - 1));

      slides.forEach(function (slide, slideIndex) {
        var isCurrent = slideIndex === current;
        slide.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        if (kind === 'transformation') slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var isCurrent = dotIndex === current;
        dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        dot.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        dot.tabIndex = isCurrent ? 0 : -1;
      });

      steps.forEach(function (step, stepIndex) {
        var isCurrent = stepIndex === current;
        step.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        step.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        step.tabIndex = isCurrent ? 0 : -1;
      });

      if (previous) {
        previous.hidden = slides.length < 2;
        previous.disabled = current === 0;
        previous.setAttribute('aria-controls', trackId);
      }
      if (next) {
        next.hidden = slides.length < 2;
        next.disabled = current === slides.length - 1;
        next.setAttribute('aria-controls', trackId);
      }
      if (progress) {
        progress.hidden = slides.length < 2;
        progress.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
    }

    function moveTo(index) {
      var current = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: slides[current].offsetLeft,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
      update(current);
    }

    if (previous) previous.addEventListener('click', function () { moveTo(getIndex(track, slides) - 1); });
    if (next) next.addEventListener('click', function () { moveTo(getIndex(track, slides) + 1); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { moveTo(Number(dot.dataset.agCfCommonIndex)); }); });
    steps.forEach(function (step) { step.addEventListener('click', function () { moveTo(Number(step.dataset.agCfCommonIndex)); }); });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveTo(getIndex(track, slides) - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveTo(getIndex(track, slides) + 1);
      }
    });

    var scrollFrame;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () { update(getIndex(track, slides)); });
    }, { passive: true });

    update(0);
  }

  function getIndex(track, slides) {
    var center = track.scrollLeft + (track.clientWidth / 2);
    var closestIndex = 0;
    var closestDistance = Infinity;

    slides.forEach(function (slide, index) {
      var distance = Math.abs((slide.offsetLeft + (slide.offsetWidth / 2)) - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initScope(scope) {
    getScopedRoots(scope).forEach(function (root) {
      root.querySelectorAll('[data-ag-cf-common-slider]').forEach(initSlider);
    });
  }

  function init() { initScope(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (!window.__agCfCommonSectionLoadBound) {
    window.__agCfCommonSectionLoadBound = true;
    document.addEventListener('shopify:section:load', function (event) { initScope(event.target); });
  }
})();
